import { render, staticRenderFns } from "./sectionLists.vue?vue&type=template&id=a06ccb8c&scoped=true"
import script from "./sectionLists.vue?vue&type=script&lang=js"
export * from "./sectionLists.vue?vue&type=script&lang=js"
import style0 from "./sectionLists.vue?vue&type=style&index=0&id=a06ccb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06ccb8c",
  null
  
)

export default component.exports